import { render, staticRenderFns } from "./UrunDuzenle.vue?vue&type=template&id=36bc40a5&scoped=true&"
import script from "./UrunDuzenle.vue?vue&type=script&lang=js&"
export * from "./UrunDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./UrunDuzenle.vue?vue&type=style&index=0&id=36bc40a5&scoped=true&lang=css&"
import style1 from "./UrunDuzenle.vue?vue&type=style&index=1&id=36bc40a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bc40a5",
  null
  
)

export default component.exports